import { search } from 'fast-fuzzy';

(function () {
    if (document.querySelector('#part-category-filter') == undefined) {
        return;
    }

    let tags = document.querySelectorAll('.part-category-listing__tag');
    let tagText = Array.from(tags).map(x => x.dataset.tag);
    let filterInput = document.querySelector('#part-category-filter');
    let filterSection = document.querySelector('.part-category-filter > section');
    let filterForm = document.querySelector('.part-category-filter');
    let tagBox = document.createElement('div');
    let tagBoxClose = document.createElement('div');
    let reset = filterForm.querySelector('button[type="reset"]');
    tagBox.id = 'part-category-filter__tag-results';
    tagBox.classList.add('hidden');
    tagBox.appendChild(tagBoxClose);

    tagBoxClose.classList.add('close');

    filterInput.addEventListener('keyup', function (e) { searchFilterTags(e) });
    reset.addEventListener('click', resetForm);
    tagBoxClose.addEventListener('click', () => tagBox.classList.add('hidden'));

    function searchFilterTags(e) {
        let results = search(e.target.value, tagText);

        updateDisplay(results);
    }

    function updateDisplay(tags) {
        let tagEls = [];

        document.querySelectorAll(".part-category-filter__tag").forEach(e => e.parentNode.removeChild(e));

        tags.forEach(el => {
            let tag = document.createElement('a');
            let tagText = document.createTextNode(el);

            tag.setAttribute('href', '?filter=' + el);
            tag.setAttribute('data-category', el);
            tag.setAttribute('class', 'part-category-filter__tag');
            tag.appendChild(tagText);

            tag.addEventListener('click', function (e) {
                e.preventDefault();
                selectTag(e);
            });

            tagEls.push(tag);
        });

        if (tags.length > 0) {
            tagBox.classList.remove('hidden');

            filterSection.appendChild(tagBox);

            tagEls.forEach(el => {
                tagBox.appendChild(el);
            });
        }
        else {
            tagBox.classList.add('hidden');
        }

        return tagEls;
    }

    function selectTag(e) {
        let tag = e.target;

        filterInput.value = tag.dataset.category;
        filterForm.submit();
    }

    function resetForm() {
        filterInput.value = "";
        filterForm.submit();
    }

    function closeTagResults() {

    }   
})();